import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import {
  portantePersonaFisicaClienteFields,
  portantePersonaGiuridicaClienteFields,
  portanteVeicoloFields,
} from "../lib/portanteCampi";
import DynamicTable from "../../rcAutoDetails2/dynamicTable";
import { Spacer } from "../style";
import ComplexTable from "../../rcAutoDetails2/complexTable";
import { ExpandMore } from "@mui/icons-material";
import CustomSelect from "../../../components/CustomSelect";
import { DatePicker } from "@mui/x-date-pickers";
import { CustomSelectMenuProps } from "../../../../constants";
import { parseDate } from "../../rcAutoDetails2/helpers";

function AccordionSection({ children, title, defaultExpanded = false }) {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h5">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

const Portante = ({ dataset, legale }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isPersonaGiuridica = !!legale;
  const Attestato = dataset["Attestato"];
  const Sinistri = dataset["sinistri"];
  const Veicolo = dataset["Veicolo"][0];
  const Cliente = dataset["Cliente"];

  const veicoloCampi = portanteVeicoloFields
    .map((field) => {
      const match = Veicolo?.[field.name]; // cerca la proprietà nell’oggetto

      if (!match) return null;

      return {
        ...field,
        value:
          typeof match === "object" && "value" in match ? match.value : match,
        dataset:
          typeof match === "object" && match.dataset ? match.dataset : null,
      };
    })
    .filter(Boolean);

  const clienteCampi = (
    isPersonaGiuridica
      ? portantePersonaGiuridicaClienteFields
      : portantePersonaFisicaClienteFields
  )
    .map((field) => {
      const match = Cliente?.[field.name]; // proprietà dell'oggetto Cliente

      if (!match) return null;

      let value;
      let dataset = [];

      if (typeof match === "object" && "value" in match) {
        // caso: select già strutturato
        value = match.value;
        dataset = match.dataset ?? [{ value: match.value, label: match.value }];
      } else {
        // caso: campo semplice (stringa/numero)
        value = match;
        dataset =
          field.type === "select" ? [{ value: match, label: match }] : null;
      }

      return {
        ...field,
        value,
        dataset,
      };
    })
    .filter(Boolean);

  return (
    <Box sx={{ width: "100%" }} display="flex" flexDirection="column" gap={4}>
      {Veicolo && (
        <Card>
          <CardContent>
            <AccordionSection title={"Veicolo"} defaultExpanded={true}>
              <Grid container spacing={3}>
                {veicoloCampi.map((field) => {
                  return (
                    <Grid item xs={12} sm={4} key={field.name}>
                      {field.type === "text" && (
                        <TextField
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={field.value}
                          fullWidth
                        />
                      )}
                      {field.type === "select" && (
                        <CustomSelect
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={field.value}
                          fullWidth
                          options={field.dataset}
                          MenuProps={CustomSelectMenuProps}
                        />
                      )}
                      {field.type === "date" && (
                        // Normal behavior for other date fields
                        <DatePicker
                          label={field.label}
                          value={field.value ? parseDate(field.value) : null}
                          onChange={() => null}
                          inputFormat="dd/MM/yyyy"
                          disabled={true}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            </AccordionSection>
          </CardContent>
        </Card>
      )}
      {Object.keys(Cliente).length > 0 && (
        <Card>
          <CardContent>
            <AccordionSection title={"Cliente"} defaultExpanded={true}>
              <Grid container spacing={3}>
                {clienteCampi.map((field) => {
                  return (
                    <Grid item xs={12} sm={4} key={field.name}>
                      {field.type === "text" && (
                        <TextField
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={field.value}
                          fullWidth
                        />
                      )}
                      {field.type === "select" && (
                        <CustomSelect
                          disabled={true}
                          label={field.label}
                          name={field.name}
                          value={field.value}
                          fullWidth
                          options={field.dataset}
                          MenuProps={CustomSelectMenuProps}
                        />
                      )}
                      {field.type === "date" && (
                        // Normal behavior for other date fields
                        <DatePicker
                          label={field.label}
                          value={field.value ? parseDate(field.value) : null}
                          onChange={() => null}
                          inputFormat="dd/MM/yyyy"
                          disabled={true}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            </AccordionSection>
          </CardContent>
        </Card>
      )}
      {Object.keys(Attestato).length > 0 && (
        <Card>
          <CardContent
            sx={{
              maxWidth: isMobile ? "calc(100vw - 40px)" : "100%",
              overflow: "auto",
            }}
          >
            <AccordionSection title={"Attestato"} defaultExpanded={true}>
              {Object.keys(Attestato).length > 0 && (
                <DynamicTable name={"Attestato"} dataset={Attestato} />
              )}
              <Spacer mb={6} />
              {Sinistri && (
                <Typography variant="h5" mb={6}>
                  Sinistri
                </Typography>
              )}
              {Sinistri && <ComplexTable dataset={Sinistri} />}
            </AccordionSection>
          </CardContent>
        </Card>
      )}
      {Object.keys(Cliente).length === 0 &&
        !Veicolo &&
        !Sinistri &&
        Object.keys(Attestato).length === 0 && (
          <Card>
            <CardContent>
              <Typography variant="h5">Nessun dato trovato</Typography>
            </CardContent>
          </Card>
        )}
    </Box>
  );
};

export default Portante;
